import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from '@angular/forms';
import { Router } from '@angular/router';
import { UserService } from '@core/services/user.service';
import { ToastrService } from 'ngx-toastr';
import { Subscription } from 'rxjs';
import { IRequestAccount } from '../../../core/interfaces/irequest-account';
import { EMAIL_REGEX } from '@core/enums/patterns';

@Component({
    selector: 'app-create-account',
    templateUrl: './create-account.component.html',
    styleUrls: ['./create-account.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class CreateAccountComponent implements OnInit {
  createAcctForm!: FormGroup;
  private subscriptions = new Subscription();
  formPayload!: IRequestAccount;

  constructor(
    private toastr: ToastrService,
    private formBuilder: FormBuilder,
    private userService: UserService,
    private router: Router
  ) {}

  get f() {
    return this.createAcctForm.controls;
  }
  ngOnInit(): void {
    this.initializeForms();
  }

  initializeForms(): void {
    this.createAcctForm = this.formBuilder.group({
      firstName: new FormControl('', [
        Validators.required,
        Validators.maxLength(100),
      ]),
      lastName: new FormControl('', [
        Validators.required,
        Validators.maxLength(100),
      ]),
      email: ['', [Validators.required, Validators.maxLength(100), Validators.pattern(EMAIL_REGEX)]],
    });
  }

  handleSubmit(form: IRequestAccount): void {
    this.formPayload = form;
    this.subscriptions.add(
      this.userService
        .createUserRequest(this.formPayload)
        .subscribe((res: any) => {
         

          if (res){
          this.toastr.success('Account created successfully! An email was sent to verify your account.');
          this.router.navigateByUrl('/login');
          }else{
            this.toastr.error('The email provided already exists. Please try a different email or Sign in.');
          }
        })
     );

    this.createAcctForm.reset();
  }


  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }
}
